import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { IMAGES } from "../mock";
import { Home } from "lucide-react";

const NotFound = () => {
  useEffect(() => {
    document.title = "Page non trouv\u00e9e - Meilleurelec.fr";
    let robotsMeta = document.querySelector('meta[name="robots"]');
    if (robotsMeta) robotsMeta.setAttribute("content", "noindex, follow");
    return () => {
      const rm = document.querySelector('meta[name="robots"]');
      if (rm) rm.setAttribute("content", "index, follow");
      document.title = "Comparer les offres d'\u00e9lectricit\u00e9 fran\u00e7aises - Meilleurelec.fr";
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center" style={{ backgroundColor: "var(--me-bg)" }}>
      <img
        src={IMAGES.logo}
        alt="Meilleurelec.fr"
        width={468}
        height={120}
        className="h-12 w-auto object-contain mb-8"
      />
      <p className="text-[80px] font-extrabold leading-none" style={{ color: "var(--me-blue)" }}>404</p>
      <h1 className="mt-2 text-[24px] font-bold" style={{ color: "var(--me-heading)" }}>
        Page non trouvée
      </h1>
      <p className="mt-2 text-[15px] max-w-md" style={{ color: "var(--me-text)" }}>
        Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
      </p>
      <Link
        to="/"
        className="mt-8 flex items-center gap-2 rounded-full px-8 py-3 text-white font-semibold transition-colors"
        style={{ backgroundColor: "var(--me-blue)" }}
        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "var(--me-blue-hover)")}
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "var(--me-blue)")}
      >
        <Home className="h-4 w-4" aria-hidden="true" />
        Retour à l'accueil
      </Link>
    </div>
  );
};

export default NotFound;
